export default __webpack_public_path__ + "static/media/circleForegroundLeft.801e5642.svg";